import { navigateTo } from 'nuxt/app'
import { type TPage } from '~/types/page-types'
import { type TRedirect } from '~/types/response-types'

// deal with (internal) redirects
export const useRedirect = (data: TPage | TRedirect) => {
  if ('to' in data) {
    data = data as TRedirect

    console.info(`ℹ Redirecting to: ${data.to}`)

    navigateTo(data.to, {
      replace: true,
      redirectCode: data.permanent ? 301 : 302,
      external: true // setting this to false breaks the router.
    })
  }
}
